import { cx } from '@emotion/css';

import { useStyles as useStylesEcp } from './reg-steps-ecp.styles';
import { useStyles } from './reg-steps.styles';
import { RegStep, RegStepProps } from './reg-step';

export const RegSteps = (
  { steps, isEcp, isChild }: { steps: RegStepProps[], isEcp?: boolean, isChild?: boolean }): JSX.Element => {
  const classes = isEcp ? useStylesEcp() : useStyles();

  return (
    <ul
      className={cx(classes.root, { 'child': isChild })}
      data-testid="reg-steps-list"
    >
      {steps.map(({
        title,
        description,
        actionContent,
        actionHref,
        icon,
        index,
        iconFirst,
        iconSecond,
        list,
        indexIcon,
      }, i) => (
        <li
          className={cx(classes.item, { 'child': isChild })}
          data-testid="reg-steps-item"
          key={i}
        >
          <RegStep
            title={title}
            description={description}
            icon={icon}
            actionContent={actionContent}
            actionHref={actionHref}
            index={index}
            iconSecond={iconSecond}
            iconFirst={iconFirst}
            list={list}
            isEcp={isEcp}
            isChild={isChild}
            indexIcon={indexIcon}
          />
        </li>
      ))}
    </ul>
  );
};
